import * as React from 'react';
import { INewBuilding } from '../../types/newBuldings';
import { CardImage } from '../CardImage';

export const MAX_IMAGES_COUNT = 4;

export function getNewBuildingImages(newBuilding: INewBuilding) {
  let imagesArr = [newBuilding.image, ...newBuilding.additionalImages];

  if (imagesArr.length > MAX_IMAGES_COUNT) {
    imagesArr = imagesArr.slice(0, MAX_IMAGES_COUNT);
  }

  return imagesArr.map((imageUrl, index) => <CardImage key={index} size={index === 0 ? 'L' : 'XS'} src={imageUrl} />);
}
